import { fetchPollDetails, FormattedPoll } from '@utils/Poll';
import cn from 'clsx';
import { useEffect, useState } from 'react';

export interface PollListCardProps
  extends React.ComponentPropsWithoutRef<'div'> {
  type?: 'fill' | 'border';
  index: number;
  isIdea?: boolean;
  poll: FormattedPoll;
  duplicate?: any;
  accessory?: JSX.Element | string;
}

const BG_COLORS = [
  'bg-yellow',
  'bg-magenta',
  'bg-orange',
  'bg-green',
  'bg-red',
  'bg-blue-light',
  'bg-purple',
  'bg-yellow',
  'bg-red-pastel',
  'bg-blue',
];

const BORDER_COLORS = [
  'border-yellow',
  'border-magenta',
  'border-orange',
  'border-green',
  'border-red',
  'border-blue-light',
  'border-purple',
  'border-yellow',
  'border-red-pastel',
  'border-blue',
];

const PollListCard: React.FC<PollListCardProps> = ({
  type = 'fill',
  className,
  index,
  isIdea = false,
  poll,
  accessory,
  duplicate = false,
  ...props
}) => {
  const COLORS = type === 'border' ? BORDER_COLORS : BG_COLORS;
  // Get color, limit by length and carousell
  let bgIndex = index;
  while (bgIndex >= COLORS.length) {
    bgIndex = bgIndex - COLORS.length;
  }

  const rootCn = cn(
    'flex items-center cursor-pointer p-2 font-display transition duration-300 ease-in-out border-2 border-salmon hover:bg-salmon',
    COLORS[bgIndex],
    { 'border-2 bg-white hover:bg-salmon': type === 'border' },
    className
  );
  const [voteCount, setVoteCount] = useState(0);

  const getPollDetail = async () => {
    const pollDetail = await fetchPollDetails('', poll.id);
    if (!isIdea)
      setVoteCount(
        pollDetail.poll.voteCount +
          (pollDetail.subPolls
            ? pollDetail.subPolls.reduce((r, a) => {
                r += a.voteCount;
                return r;
              }, 0)
            : 0)
      );
  };

  useEffect(() => {
    if (!isIdea) getPollDetail();
    console.log(!!duplicate);
  }, []);

  return (
    <div className={rootCn} {...props}>
      <div>
        <div className="w-10 h-10 rounded-full">
          <img
            className="object-cover w-full h-full rounded-full"
            src={poll.image?.url}
            alt="poll"
          />
        </div>
      </div>
      <div className="flex flex-col flex-1 w-full ml-4 mr-2">
        <div
          className="text-lg font-bold leading-5 break-words"
          style={{ hyphens: 'auto' }}
        >
          {poll.title}
        </div>
        {!isIdea && (
          <div className="text-xs font-semibold">{voteCount} votes</div>
        )}
      </div>
      {!!duplicate && (
        <div
          style={{ marginRight: 10, color: 'blue' }}
          onClick={(event: any) => {
            event.preventDefault();
            event.stopPropagation();
            duplicate(poll);
          }}
          className="flex items-center font-semibold capitalize"
        >
          Duplicate
        </div>
      )}
      {accessory && (
        <div className="flex items-center font-semibold capitalize">
          {accessory}
        </div>
      )}
    </div>
  );
};

export default PollListCard;
